var Header                      = require("./Header"),
    MultiSeasonCarouselRow      = require("./MultiSeasonCarouselRow"),
    MultiSeasonGridRow          = require("./MultiSeasonGridRow"),
    PrefixedScrollRepeater      = require("app/ui/repeaters/PrefixedScrollRepeater"),
    RepeaterPaddedListArranger  = require("enyo-ui/RepeaterPaddedListArranger"),
    ScrollAnchorMemorySupport   = require("app/ui/ScrollAnchorMemorySupport"),
    ScrollerDecoratorScrollbars = require("app/ui/ScrollerDecoratorScrollbars"),
    SingleSeasonCarouselRow     = require("./SingleSeasonCarouselRow"),
    SingleSeasonGridRow         = require("./SingleSeasonGridRow"),
    frameThrottle               = require("enyo-perf/utils").frameThrottle,
    get                         = require("object-path").get,
    kind                        = require("enyo/kind"),
    quickMacroize               = require("enyo/macroize").quickMacroize,
    resolveCategoryRowKind      = require("app/utils/resolveCategoryRowKind"),
    themeVars                   = require("app/theme/variables");

require("./PageView.less");
require("app/theme/ScrollerDecoratorScrollbars--page.less");

module.exports = kind(/** @lends  app.SeriesPage.PageView.prototype */ {

    /**
     * @private
     */
    name: "app.SeriesPage.PageView",

    /**
     * @private
     */
    kind: ScrollerDecoratorScrollbars,

    /**
     * @private
     */
    classes: "app-series-page-page-view",

    /**
     * @private
     */
    fit: true,

    /**
     * @public
     */
    scrollerPath: ".$.categories.$.scroller",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * Default scroll-bars theme for desktop, minimal for mobile.
     *
     * @public
     */
    theme: "page",

    /**
     * If true, chrome will show when scrolling, hide when not scrolling.
     *
     * @type  {boolean}
     * @public
     */
    fadeChromeOnScroll: true,

    /**
     * @private
     */
    components: [{
        name:       "categories",
        kind:       PrefixedScrollRepeater,
        mixins:     [ScrollAnchorMemorySupport],
        classes:    "app-series-page-page-view__categories",
        components: [{
            name:    "header",
            kind:    Header,
            classes: "app-series-page-page-view__header"
        }],
        drawAsync:       true,
        scrollerOptions: {
            fit: true
        },
        arrangerKind:    RepeaterPaddedListArranger,
        arrangerOptions: {
            direction:        "vertical",
            defaultChildSize: 200,

            /**
             * The amount of padding before the first child.
             *
             * @return {number}  The padding
             * @public
             */
            padBefore: function() {
                return themeVars.getContentPaddingVerticalPx();
            },

            /**
             * The amount of padding after the last child.
             *
             * @return {number}  The padding
             * @public
             */
            padAfter: function() {
                return themeVars.getContentPaddingVerticalPx() * 2;
            }
        },

        /**
         * Return the right kind of row depending on the type of item.
         *
         * @param  {?string}       item  The item
         * @return {enyo.Control}  The row kind
         * @public
         */
        getChildKind: function(item) {
            if (item.type === "season") {
                switch (item.serial_layout) {
                    case "carousel_page":
                        return SingleSeasonCarouselRow;
                    case "grid_page":
                        return SingleSeasonGridRow;
                    case "carousel_dropdown":
                        return MultiSeasonCarouselRow;
                    case "grid_dropdown":
                    default:
                        return MultiSeasonGridRow;
                }
            }
            else {
                return resolveCategoryRowKind(item);
            }
        }
    }],

    /**
     * @private
     */
    handlers: {
        onDropdownOpen:   "onDropdownOpen",
        onDropdownHidden: "onDropdownHidden"
    },

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state       = this.state || {},
            seasons,
            $categories = this.$.categories,
            anchorKey   = get(state, "seasonData", null)
                ? quickMacroize("SeriesPage/PageView/{$slug}/season/{$seasonNr}", {
                    slug:     get(state, "data.meta.slug", null),
                    seasonNr: get(state, "seasonData.serial_nr", null)
                })
                : quickMacroize("SeriesPage/PageView/{$slug}", {
                    slug: get(state, "data.meta.slug", null)
                });

        this.$.header.set("data", get(state, "data", null));

        $categories.set("state", state);

        // Get seasons data
        switch (get(state, "data.serial_layout", "grid_dropdown")) {
            case "carousel_page":
            case "grid_page":
                seasons = get(state, "data.children", []);
                break;
            case "carousel_dropdown":
            case "grid_dropdown":
            default:
                seasons = [get(state, "seasonData", null)];
                break;
        }

        switch (get(state, "data.embedded_dashboard_position", "bottom")) {
            case "top":
                $categories.set("data", get(state, "data.dashboard", []).concat(seasons));
                break;
            case "bottom":
            default:
                $categories.set("data", seasons.concat(get(state, "data.dashboard", [])));
                break;
        }
        $categories.set("anchorKey", anchorKey);

        anchorKey && $categories.restoreAnchor();
    },

    /**
     * Update dropdown menu maxHeight in relation to repeater's
     * childContainerSize and scroll the entire dropdown menu into view when
     * it opens.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Event}         event   The event
     * @private
     */
    onDropdownOpen: function(sender, event) {
        var dropdownOwner = event.originator.$.dropdown.owner;

        this.observe("$.categories.childContainerSize", dropdownOwner.reflow, dropdownOwner);
        dropdownOwner.reflow();
    },

    /**
     * Stop responding to changes in childContainerSize.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Event}         event   The event
     * @private
     */
    onDropdownHidden: function(sender, event) {
        var dropdownOwner = event.originator.$.dropdown.owner;
        this.unobserve("$.categories.childContainerSize", dropdownOwner.reflow, dropdownOwner);
    }

});
